<template>
  <div>
    <h1></h1>
    <ul>
      <li v-for="record in quotationRecords" :key="record.userid">
        <p><strong>货代名称:</strong> {{ record.company }}</p>
        <p><strong>货代排名:</strong> {{ record.ranking }}</p>
        <p><strong>报价备注:</strong> {{ record.memo }}</p>
        <hr>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        quotationRecords: [],
        url: {
          queryQuotationRecord: '/bookspaceinquiry/queryQuotationRecord',   //查询本单详情，get，传formid和type
        },
      };
    },
    mounted() {
      this.fetchQuotationRecords();
    },
    methods: {
      async fetchQuotationRecords() {
        try {
          this.$get(this.url.queryQuotationRecord, this.$route.query).then(res => {
            if(res.code === 200) {
              this.quotationRecords = res.result
            } else {
              this.$message.error(res.message)
            }
          })
          /*
                              const response = await fetch('http://10.16.83.32:9991/jeecg-boot/bookspaceinquiry/queryQuotationRecord?type=比价订舱&formid=肖邦20248221718');
                              const data = await response.json();
                              if (data.success) {
                                  this.quotationRecords = data.result;
                              } else {
                                  console.error(data.message);
                              }*/
        } catch (error) {
          console.error(error);
        }
      }
    }
  };
</script>
